import { patientAction, therapyPlanningAction } from 'src/redux/actions/constant';

const {
  REQUEST_UPLOAD_MDS_CSV_TEMPLATE,
  SUCCESS_UPLOAD_MDS_CSV_TEMPLATE,
  FAILURE_UPLOAD_MDS_CSV_TEMPLATE,
  RESET_UPLOAD_MDS_CSV_TEMPLATE,
  LOADING_UPLOAD_MDS_CSV_TEMPLATE,
} = therapyPlanningAction;
const intitialstate: object = {
  isUploadSuccess: false,
  response: null,
  loading: false,
};

export const uploadCsvTemplateMdsReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_UPLOAD_MDS_CSV_TEMPLATE: {
      return {
        ...state,
        isUploadSuccess: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_UPLOAD_MDS_CSV_TEMPLATE:
      return {
        ...state,
        isUploadSuccess: false,
        response: action.payload,
        loading: false,
      };

    case LOADING_UPLOAD_MDS_CSV_TEMPLATE:
      return {
        ...state,
        loading: true,
      };

    case RESET_UPLOAD_MDS_CSV_TEMPLATE:
      return intitialstate;

    default:
      return state;
  }
};
